module.exports = __webpack_public_path__ + "static/media/awschd32_401.327a09df.ico";